export default "__VITE_ASSET__c88b96cd__"